import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import { medicalQuestionnarieFormList } from '@/models/reserve/medicalQuestionnarieModel';
import MedicalQuestionnarieRepository from '@/repositories/medicalQuestionnarieRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

// メッセージダイアログ取得
export const useMedicalQuestionnarieStore = defineStore({
    id: 'medicalQuestionnarie',
    state: () => ({
        reservationPk: '',
        formPk: '',
        medicalQuestionnarieFormAnswer: [],
        medicalQuestionnarieForm: new medicalQuestionnarieFormList(),
    }),
    actions: {
        reset() {
            this.reservationPk = '';
            this.formPk = '';
            this.medicalQuestionnarieFormAnswer = [];
            this.medicalQuestionnarieForm = new medicalQuestionnarieFormList();
        },
        /**
         * 問診票フォーム取得処理
         */
        async getMedicalQuestionnarieForm(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const medicalQuestionnarieRepository = new MedicalQuestionnarieRepository();
            try {
                const response = await medicalQuestionnarieRepository.getMedicalQuestionnarieFormActionApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.medicalQuestionnarieForm = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * 問診票フォーム登録処理
         */
        async putMedicalQuestionnarieForm(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const medicalQuestionnarieRepository = new MedicalQuestionnarieRepository();
            try {
                const response = await medicalQuestionnarieRepository.putMedicalQuestionnarieFormActionApi(API_URL, queryParam, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.medicalQuestionnarieForm = response.data;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        //セッションストレージに保存
        storage: sessionStorage,
    },
});
